import type { ColumnDef } from './DataTable'

export const parseWidth = (width: number | string | undefined): number => {
  return typeof width === 'number' ? width : parseFloat(width ?? '') || 0
}

export interface StickyStylesResult {
  leftOffsets: Record<string, number>
  rightOffsets: Record<string, number>
  checkboxWidth: number
}

export const calculateStickyStyles = <TRowModel>(
  columns: ColumnDef<TRowModel>[],
  selectable: boolean
): StickyStylesResult => {
  const checkboxWidth = selectable ? 40 : 0
  let leftOffset = checkboxWidth
  let rightOffset = 0
  const leftOffsets: Record<string, number> = {}
  const rightOffsets: Record<string, number> = {}

  columns.forEach((column) => {
    if (column.sticky === 'left') {
      leftOffsets[column.name] = leftOffset
      const width = parseWidth(column.width)
      leftOffset += width
    }
  })

  for (let i = columns.length - 1; i >= 0; i--) {
    const column = columns[i]
    if (column.sticky === 'right') {
      rightOffsets[column.name] = rightOffset
      const width = parseWidth(column.width)
      rightOffset += width
    }
  }

  return { leftOffsets, rightOffsets, checkboxWidth }
}
